import { atom } from 'recoil';

import { persistAtomOnSessionStorage } from '@asa/asasqt-microfrontend-components/dist/common/state/recoilPersist';

export const credentialsAtom = atom({
  key: 'credentials',
  default: undefined,
});
export const setRememberMeFlagAtom = atom<boolean>({
  key: 'setRememberMeFlag',
  default: false,
  effects_UNSTABLE: [persistAtomOnSessionStorage],
});

export const hasLicenseAtom = atom({
  key: 'hasLicense',
  default: undefined as unknown as boolean,
});
